/**
 * VerifyPage.js
 * Public page for field team to access verification form
 * No authentication required - accessed via shared link
 */

import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from '../utils/ThemeSwitcher';
import FieldFeedbackForm from '../components/cleaning/FieldFeedbackForm';

const VerifyPage = () => {
  const { sessionId } = useParams();
  const { isDarkMode } = useTheme();

  // Load Outfit font
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap';
    link.rel = 'stylesheet';
    if (!document.querySelector('link[href*="Outfit"]')) {
      document.head.appendChild(link);
    }
  }, []);
  
  if (!sessionId) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '40px',
        textAlign: 'center',
        fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
        backgroundColor: isDarkMode ? '#08090B' : '#FFFFFF',
        color: isDarkMode ? '#6d6e74' : '#111214',
      }}>
        <h2 style={{ marginBottom: '8px' }}>Invalid Link</h2>
        <p style={{ color: isDarkMode ? '#8B8D97' : '#6B7280' }}>
          This verification link appears to be invalid or incomplete.
        </p>
        <style>{`
          ::-webkit-scrollbar { width: 6px; }
          ::-webkit-scrollbar-track { background: transparent; }
          ::-webkit-scrollbar-thumb { background: ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}; border-radius: 3px; }
          ::-webkit-scrollbar-thumb:hover { background: ${isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'}; }
        `}</style>
      </div>
    );
  }
  
  return (
    <>
      <FieldFeedbackForm sessionId={sessionId} isDarkMode={isDarkMode} />
      <style>{`
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: ${isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'}; }
      `}</style>
    </>
  );
};

export default VerifyPage;